import { Council } from 'types';

export const getCouncilAssistants = (council: Council) => {
  const assistants = council?.participants.filter(
    (participant) => participant?.assists
  );
  return assistants;
};
